import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const IkiFaktorluDogrulamaNedir = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('ikiFaktorluDogrulamaNedir.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('ikiFaktorluDogrulamaNedir.subtitle')}</h3>
                        <p className="academy-intro-text">{t('ikiFaktorluDogrulamaNedir.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('ikiFaktorluDogrulamaNedir.intro.p2')}</p>
                        <ul className="academy-list">
                            {t('ikiFaktorluDogrulamaNedir.intro.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 1: 2FA Nedir? */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaNedir.section1.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaNedir.section1.definition')}</p>
                        
                        {/* Basit Örnek */}
                        <div className="academy-example-box">
                            <h5>{t('ikiFaktorluDogrulamaNedir.section1.example.title')}</h5>
                            <p>{t('ikiFaktorluDogrulamaNedir.section1.example.intro')}</p>
                            <ul>
                                {t('ikiFaktorluDogrulamaNedir.section1.example.steps', { returnObjects: true }).map((step, index) => (
                                    <li key={index}>{step}</li>
                                ))}
                            </ul>
                            <p className="mt-3 fw-bold">{t('ikiFaktorluDogrulamaNedir.section1.example.conclusion')}</p>
                        </div>

                        {/* Dijital Dünyada 2FA */}
                        <div className="academy-highlight-box mt-4">
                            <h5>{t('ikiFaktorluDogrulamaNedir.section1.digital.title')}</h5>
                            <p>{t('ikiFaktorluDogrulamaNedir.section1.digital.intro')}</p>
                            <ul>
                                {t('ikiFaktorluDogrulamaNedir.section1.digital.factors', { returnObjects: true }).map((factor, index) => (
                                    <li key={index}>{factor}</li>
                                ))}
                            </ul>
                            <p className="mt-3">{t('ikiFaktorluDogrulamaNedir.section1.digital.conclusion')}</p>
                        </div>

                        {/* Karşılaştırma Tablosu */}
                        <h4 className="mt-5">{t('ikiFaktorluDogrulamaNedir.section1.comparison.title')}</h4>
                        <div className="academy-table-wrapper">
                            <table className="academy-table">
                                <thead>
                                    <tr>
                                        <th>{t('ikiFaktorluDogrulamaNedir.section1.comparison.header1')}</th>
                                        <th>{t('ikiFaktorluDogrulamaNedir.section1.comparison.header2')}</th>
                                        <th>{t('ikiFaktorluDogrulamaNedir.section1.comparison.header3')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {t('ikiFaktorluDogrulamaNedir.section1.comparison.rows', { returnObjects: true }).map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.scenario}</td>
                                            <td>{row.passwordOnly}</td>
                                            <td>{row.with2FA}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="academy-highlight-box text-white mt-4">
                            <h5 className="text-white">{t('ikiFaktorluDogrulamaNedir.section1.statistic.title')}</h5>
                            <p className="mb-0">{t('ikiFaktorluDogrulamaNedir.section1.statistic.text')}</p>
                        </div>
                    </div>
                </div>

                {/* Bölüm 2: 2FA Nasıl Çalışır? */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaNedir.section2.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaNedir.section2.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaNedir.section2.steps', { returnObjects: true }).map((step, index) => (
                            <div className="academy-step-card mb-4">
                                <div className="step-content">
                                    <h4>{step.title}</h4>
                                    <p>{step.description}</p>
                                    {step.details && (
                                        <ul>
                                            {step.details.map((detail, dIdx) => (
                                                <li key={dIdx}>{detail}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {step.example && (
                                        <div className="academy-example-box mt-2">
                                            <small>{step.example}</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 3: 2FA Yöntemleri */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaNedir.section3.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaNedir.section3.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaNedir.section3.methods', { returnObjects: true }).map((method, index) => (
                            <div className="academy-type-card mb-4" key={index}>
                                <h4>{method.name}</h4>
                                <p className="">{method.apps}</p>
                                
                                <div className="mt-3">
                                    <h6>{t('ikiFaktorluDogrulamaNedir.section3.howItWorksLabel')}</h6>
                                    <ul>
                                        {method.how.map((item, hIdx) => (
                                            <li key={hIdx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-6">
                                        <h6 className="text-success">{t('ikiFaktorluDogrulamaNedir.section3.advantagesLabel')}</h6>
                                        <ul>
                                            {method.advantages.map((adv, aIdx) => (
                                                <li key={aIdx}>{adv}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="col-md-6">
                                        <h6 className="text-danger">{t('ikiFaktorluDogrulamaNedir.section3.disadvantagesLabel')}</h6>
                                        <ul>
                                            {method.disadvantages.map((dis, dIdx) => (
                                                <li key={dIdx}>{dis}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 4: Neden Bu Kadar Önemli? */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaNedir.section4.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaNedir.section4.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaNedir.section4.reasons', { returnObjects: true }).map((reason, index) => (
                            <div className="academy-highlight-box mb-4" key={index}>
                                <h5>{reason.title}</h5>
                                <p>{reason.description}</p>
                                {reason.stats && (
                                    <ul>
                                        {reason.stats.map((stat, sIdx) => (
                                            <li key={sIdx}>{stat}</li>
                                        ))}
                                    </ul>
                                )}
                                {reason.note && (
                                    <div className="academy-example-box mt-3">
                                        <p className="mb-0 fw-bold">{reason.note}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 5: Gerçek Dünya Örnekleri */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaNedir.section5.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaNedir.section5.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaNedir.section5.cases', { returnObjects: true }).map((caseStudy, index) => (
                            <div className="academy-example-box mb-4" key={index}>
                                <h5>{caseStudy.title}</h5>
                                <p><strong>{t('ikiFaktorluDogrulamaNedir.section5.userLabel')}</strong> {caseStudy.user}</p>
                                <p><strong>{t('ikiFaktorluDogrulamaNedir.section5.situationLabel')}</strong> {caseStudy.situation}</p>
                                
                                <div className="mt-3">
                                    <strong>{t('ikiFaktorluDogrulamaNedir.section5.eventLabel')}</strong>
                                    <ul>
                                        {caseStudy.event.map((item, eIdx) => (
                                            <li key={eIdx}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="academy-highlight-box  text-white mt-3">
                                    <p className="mb-0"><strong>{t('ikiFaktorluDogrulamaNedir.section5.resultLabel')}</strong> {caseStudy.result}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 6: Avantajlar */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaNedir.section6.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaNedir.section6.intro')}</p>
                        
                        <div className="row g-4">
                            {t('ikiFaktorluDogrulamaNedir.section6.benefits', { returnObjects: true }).map((benefit, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-advantage-card">
                                        <h5>{benefit.title}</h5>
                                        <p className="mb-0">{benefit.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Özet */}
                <div className="academy-summary-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaNedir.summary.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaNedir.summary.p1')}</p>
                        
                        <div className="academy-highlight-box">
                            <h5>{t('ikiFaktorluDogrulamaNedir.summary.howItWorks.title')}</h5>
                            <ul>
                                {t('ikiFaktorluDogrulamaNedir.summary.howItWorks.factors', { returnObjects: true }).map((factor, index) => (
                                    <li key={index}>{factor}</li>
                                ))}
                            </ul>
                            <p className="mt-2 mb-0">{t('ikiFaktorluDogrulamaNedir.summary.howItWorks.conclusion')}</p>
                        </div>

                        <p className="academy-section-text mt-4"><strong>{t('ikiFaktorluDogrulamaNedir.summary.bestMethod')}</strong></p>

                        <div className="academy-highlight-box mt-3">
                            <h5>{t('ikiFaktorluDogrulamaNedir.summary.whyImportant.title')}</h5>
                            <ul className="mb-0">
                                {t('ikiFaktorluDogrulamaNedir.summary.whyImportant.reasons', { returnObjects: true }).map((reason, index) => (
                                    <li key={index}>{reason}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="academy-highlight-box  text-white mt-4">
                            <h5 className="text-white">{t('ikiFaktorluDogrulamaNedir.summary.conclusion.title')}</h5>
                            <p className="mb-0 fw-bold">{t('ikiFaktorluDogrulamaNedir.summary.conclusion.text')}</p>
                        </div>

                        <p className="academy-section-text mt-4 text-center">
                            <strong>{t('ikiFaktorluDogrulamaNedir.summary.nextGuide')}</strong>
                        </p>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default IkiFaktorluDogrulamaNedir;
